__turbopack_context__.v({
  "arrowButton": "StockPricesBox-module__fRhhfa__arrowButton",
  "arrowButtonSvgArrow": "StockPricesBox-module__fRhhfa__arrowButtonSvgArrow",
  "arrowButtonSvgBackground": "StockPricesBox-module__fRhhfa__arrowButtonSvgBackground",
  "box": "StockPricesBox-module__fRhhfa__box",
  "container": "StockPricesBox-module__fRhhfa__container",
  "darkMode": "StockPricesBox-module__fRhhfa__darkMode",
  "item": "StockPricesBox-module__fRhhfa__item",
  "itemDate": "StockPricesBox-module__fRhhfa__itemDate",
  "itemTitle": "StockPricesBox-module__fRhhfa__itemTitle",
  "itemValueAbs": "StockPricesBox-module__fRhhfa__itemValueAbs",
  "itemValueRel": "StockPricesBox-module__fRhhfa__itemValueRel",
  "itemValueRelContainer": "StockPricesBox-module__fRhhfa__itemValueRelContainer",
  "leftGradient": "StockPricesBox-module__fRhhfa__leftGradient",
  "negative": "StockPricesBox-module__fRhhfa__negative",
  "positive": "StockPricesBox-module__fRhhfa__positive",
  "rightGradient": "StockPricesBox-module__fRhhfa__rightGradient",
});
